import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useQuery } from "@tanstack/react-query";
import { apiClient } from "~/lib/orpc-client";
import { QUERY_KEYS } from "~/constants/queryKeys";
import CollaboratorDetailHeader from "~/components/application/shared/collaborator-detail-header";
import CollaboratorInfoCard from "~/components/application/shared/collaborator-info-card";
import { useTenantPath } from "~/hooks/use-tenant-path";

export const Route = createFileRoute(
  "/$tenantSlug/applications/$applicationId/collaborators/$collaboratorId"
)({
  component: TenantCollaboratorDetail,
});

function TenantCollaboratorDetail() {
  const { applicationId, collaboratorId } = Route.useParams();
  const navigate = useNavigate();
  const tenantPath = useTenantPath();

  const { data: collaboratorData, isLoading, isError } = useQuery({
    queryKey: QUERY_KEYS.COLLABORATOR_BY_ID(collaboratorId),
    queryFn: () => apiClient.collaborators.getById({ id: Number(collaboratorId) }),
    enabled: !!collaboratorId,
  });

  const handleBackClick = () => {
    navigate({
      to: tenantPath(`/applications/${applicationId}`),
      params: { applicationId },
    });
  };

  if (isLoading) {
    return (
      <div className="min-h-screen bg-gray-50">
        <div className="max-w-6xl mx-auto p-6">
          <p>Loading collaborator details...</p>
        </div>
      </div>
    );
  }

  if (isError || !collaboratorData) {
    return (
      <div className="min-h-screen bg-gray-50">
        <div className="max-w-6xl mx-auto p-6">
          <p className="text-destructive">Failed to load collaborator details</p>
        </div>
      </div>
    );
  }

  const { collaborator } = collaboratorData;

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="max-w-6xl mx-auto p-6 space-y-6">
        <CollaboratorDetailHeader collaborator={collaborator as any} applicationId={applicationId} onBackClick={handleBackClick} />
        <CollaboratorInfoCard collaborator={collaborator as any} />
      </div>
    </div>
  );
}
